import { Vertex } from '@thirdPartyLibraries/three-mesh-halfedge/src';
import PriorityQueue from '@common/PriorityQueue.ts';

function aStar(start: Vertex, end: Vertex): Vertex[] | null {
  const frontier = new PriorityQueue<Vertex>();
  frontier.insert(start, 0);

  const cameFrom = new Map<Vertex, Vertex | null>();
  const costSoFar = new Map<Vertex, number>();
  cameFrom.set(start, null);
  costSoFar.set(start, 0);

  while (!frontier.isEmpty()) {
    const current = frontier.pop();
    if (!current) break; // Safety check

    if (current === end) {
      return reconstructPath(cameFrom, end);
    }

    for (const neighbor of current.adjacentVertices()) {
      const newCost = costSoFar.get(current)! + 1; // We know current exists in costSoFar

      if (!costSoFar.has(neighbor) || newCost < costSoFar.get(neighbor)!) {
        costSoFar.set(neighbor, newCost);
        const priority = newCost + heuristic(neighbor, end);
        frontier.insert(neighbor, priority);
        cameFrom.set(neighbor, current);
      }
    }
  }
  return null;
}

function reconstructPath(cameFrom: Map<Vertex, Vertex | null>, end: Vertex): Vertex[] {
  const path: Vertex[] = [];
  let current: Vertex | null = end;

  while (current !== null) {
    path.push(current);
    current = cameFrom.get(current) || null;
  }

  return path.reverse(); // Return path from start to end
}

function heuristic(a: Vertex, b: Vertex): number {
  const dx = Math.abs(a.position.x - b.position.x);
  const dy = Math.abs(a.position.y - b.position.y);
  const dz = Math.abs(a.position.z - b.position.z);
  return dx + dy + dz;
}

export default aStar;
